import React from "react";

function DisableIf({disabled, children}) {
  const _children = Array.isArray(children)
    ? children
    : typeof children === "function"
    ? [children({disabled})]
    : [children];

  const style = {
    opacity: disabled && 0.65,
    pointerEvents: disabled ? "none" : "auto",
  };

  return (
    <>
      {_children
        .filter((element) => Boolean(element))
        .map((element, index) => {
          return (
            <React.Fragment key={index}>
              {React.cloneElement(element, {
                style: style,
              })}
            </React.Fragment>
          );
        })}
    </>
  );
}

export default DisableIf;
